import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentStep: 0,
    maxStep: 0,
    bgCurrent: 0,
    bgMax: 20
  },
  mutations: {
    decrement (state) {
      if (state.currentStep >= 2) {
        state.currentStep--
      }
    },
    increment (state) {
      if (state.currentStep < state.maxStep) {
        state.currentStep++
      }
    },
    prevslide (state) {
      if (state.bgCurrent >= 1) {
        state.bgCurrent--
      }
    },
    nextslide (state) {
      if (state.bgCurrent < state.bgMax) {
        state.bgCurrent++
      }
    }
  },
  actions: {
    decrement: ({ commit }) => commit('decrement'),
    increment: ({ commit }) => commit('increment'),
    prevslide: ({ commit }) => commit('prevslide'),
    nextslide: ({ commit }) => commit('nextslide'),
    incrementAsync ({ commit }) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          commit('increment')
          resolve()
        }, 1000)
      })
    }
  }
})
